import { useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import AppBarContainer from "modules/app/menu/AppBarContainer";
import { useI18n } from "i18n";
import { PAGES, usePageTracking } from "modules/tracking";
import { usePageSettingReducerActions } from "modules/pageSetting/context/pageSettingReducer";
import { SettingsContainer } from "./components/SettingsContainer";

interface MatchParams {
  pageId: string;
}

type SettingsPageProps = RouteComponentProps<MatchParams>;

const SettingsPage = ({
  match: {
    params: { pageId },
  },
}: SettingsPageProps): JSX.Element => {
  const { setPageTitle } = usePageSettingReducerActions();
  const { t } = useI18n(["menu"]);

  usePageTracking(PAGES.ACCOUNT_SETTINGS);

  useEffect(() => {
    setPageTitle(t("menu:account.settings"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);
  return (
    <>
      <AppBarContainer title={t("menu:account.settings")} />
      <SettingsContainer pageId={pageId} />
    </>
  );
};

export default SettingsPage;
